import { render, staticRenderFns } from "./applicationTextbookList.vue?vue&type=template&id=37240a06&scoped=true&"
import script from "./applicationTextbookList.vue?vue&type=script&lang=js&"
export * from "./applicationTextbookList.vue?vue&type=script&lang=js&"
import style0 from "./applicationTextbookList.vue?vue&type=style&index=0&id=37240a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37240a06",
  null
  
)

export default component.exports